import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85e54262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-detail" }
const _hoisted_2 = {
  key: 0,
  class: "organization-detail__back"
}
const _hoisted_3 = {
  key: 1,
  class: "organization-detail__content"
}
const _hoisted_4 = { class: "organization-detail__about" }
const _hoisted_5 = { class: "organization-detail__header" }
const _hoisted_6 = { class: "text-bold" }
const _hoisted_7 = { class: "organization-detail__subtitle" }
const _hoisted_8 = { class: "organization-detail__info" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Адрес:")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ИНН:")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Телефон:")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Сайт:")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Уровень доступа:")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Статус:")
const _hoisted_15 = {
  key: 2,
  class: "organization-detail__search"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { AxiosErrorType, OrganizationType, UserType } from '@/shared/types'
import { organizationsApi, userApi, usersApi } from '@/shared/api'
import UserListing from '@/widgets/WOrganizationDetailSidebar/components/UserListing.vue'
import UserOrganizationsListing from '@/widgets/WOrganizationDetailSidebar/components/UserOrganizationsListing.vue'
import { showErrorMessage } from '@/shared/utils'
import { useUserListing } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const loading = ref(false)
const searchingData = ref('')

const users = ref<UserType[]>([])
const organizations = ref<OrganizationType[]>()

const organization = ref<OrganizationType>({
  address: '',
  block_at: undefined,
  id: 0,
  inn: '',
  phone: '',
  site: '',
  is_test: '',
  is_blocked: '',
  name: '',
  package_count: '',
  reports_count: 0,
  users_count: 0,
  logo: undefined,
})

const { dateUserListing, isUserListingUpdated, setUpdateUserListing } =
  useUserListing()

const organizationId = computed<string | string[]>(
  () => route.params.organizationId
)

const userId = computed<string | string[]>(() => route.params.userId)

const isOrganizationDetailPage = computed(() =>
  route.path.includes('/organizations')
)
const isStatisticPage = computed(() => route.path.includes('show'))

const isShowUsers = computed(
  () => isOrganizationDetailPage.value || !isStatisticPage.value
)

watch(organizationId, (newOrganizationId) => {
  if (isOrganizationDetailPage.value && newOrganizationId) {
    getOrganizationInfo()
  } else {
    getUsers()
  }
})

const handleInputSearch = (): void => {
  const minCountLettersSearch = 2
  const resetValueSearch = 0

  if (
    searchingData.value.length > minCountLettersSearch ||
    searchingData.value.length === resetValueSearch
  ) {
    getUsers()
  }
}

const getOrganizationInfo = async (): Promise<void> => {
  const [error, response] = await organizationsApi.getOrganizationInfo(
    Number(organizationId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    organization.value = response.data.organization
  }
}

const getOrganizations = async (): Promise<void> => {
  loading.value = true

  const [error, response] = await userApi.getUser(Number(userId.value))

  if (error) {
    showErrorMessage(error)
  } else {
    organizations.value = response.data.user.organization
  }

  loading.value = false
}

const getUsers = async (): Promise<void> => {
  loading.value = true

  if (organizationId.value === 'all') {
    const [error, response] = await usersApi.getAllUsers(searchingData.value)

    handleResponse(response?.data.users, error)
  } else if (organizationId.value) {
    const filter = dateUserListing.value

    const [error, response] = await usersApi.getUsers(
      Number(organizationId.value),
      searchingData.value,
      filter
    )

    handleResponse(response?.data.user, error)
  }

  loading.value = false
}

const handleResponse = (response: UserType[], error: AxiosErrorType) => {
  if (error) {
    showErrorMessage(error)
  } else {
    users.value = response
  }
}

const handleOpenOrganizationStatistic = (): void => {
  router.push({
    name: 'OrganizationPage',
    params: { organizationId: organizationId.value },
  })
}

const handleComeBack = (): void => {
  if (isOrganizationDetailPage.value) {
    router.push({
      name: 'OrganizationStatisticPage',
      params: { organizationId: organizationId.value },
    })
  } else {
    router.push({ name: 'UserListingPage' })
  }
}

const handleOpenOrganizationEditionPage = (): void => {
  router.push({
    name: 'OrganizationEditionPage',
    params: { organizationId: organizationId.value },
  })
}

watch(isUserListingUpdated, (isUpdated) => {
  if (isUpdated && isShowUsers.value) {
    setUpdateUserListing(false)
    getUsers()
  }
})

onMounted((): void => {
  if (!isShowUsers.value) {
    getOrganizations()
  }

  if (isOrganizationDetailPage.value) {
    getOrganizationInfo()
  }
  getUsers()
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isStatisticPage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_icon_template, {
            class: "organization-detail__back-icon",
            height: "10",
            name: "back",
            width: "6",
            onClick: handleComeBack
          }),
          _createElementVNode("p", {
            class: "organization-detail__back-text",
            onClick: handleComeBack
          }, " Список организаций ")
        ]))
      : _createCommentVNode("", true),
    (_unref(isOrganizationDetailPage))
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(organization.value.name), 1),
              _createVNode(_component_icon_template, {
                class: "organization-detail__icon",
                height: "12",
                name: "tools",
                width: "12",
                onClick: handleOpenOrganizationEditionPage
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, "№" + _toDisplayString(organization.value.id), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 17 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.address), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 17 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.inn), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 17 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.phone), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 17,
                    class: "organization-detail__info-item--text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.site), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 17 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.is_test ? 'Ограниченный' : 'Полный'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "organization-detail__info-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 17 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(organization.value.is_blocked ? 'Не активна' : 'Активна'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_unref(isShowUsers))
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: searchingData.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchingData).value = $event)),
                clearable: "",
                placeholder: "ФИО, номер, организация",
                size: "small",
                onInput: handleInputSearch
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])),
    (_unref(isShowUsers))
      ? _withDirectives((_openBlock(), _createBlock(UserListing, {
          key: 3,
          users: users.value,
          class: "organization-detail__users"
        }, null, 8, ["users"])), [
          [_directive_loading, loading.value]
        ])
      : _withDirectives((_openBlock(), _createBlock(UserOrganizationsListing, {
          key: 4,
          organizations: organizations.value,
          class: "organization-detail__users"
        }, null, 8, ["organizations"])), [
          [_directive_loading, loading.value]
        ])
  ]))
}
}

})